"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactI18next = require("react-i18next");
var _API_ERROR_CODES = _interopRequireDefault(require("../constants/errorCodes/API_ERROR_CODES"));
var _CUSTOM_ERROR_CODES = _interopRequireDefault(require("../constants/errorCodes/CUSTOM_ERROR_CODES"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Custom Hook to map error codes with error message
 * Uses useTranslation hook
 * This file will grow with more codes
 */

function useAPIError() {
  var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var errorMessage = '';
  if (code === _API_ERROR_CODES["default"].TF3004) {
    errorMessage = t('branch_not_same_city');
  }
  if (code === _API_ERROR_CODES["default"].TF3003) {
    errorMessage = t('Invalid Pickup Date');
  }
  if (code === _API_ERROR_CODES["default"].TF3002) {
    errorMessage = t('Branch_not_found');
  }
  if (code === _API_ERROR_CODES["default"].TF3001) {
    errorMessage = t('Branch_not_found');
  }
  if (code === _API_ERROR_CODES["default"].TF3000) {
    errorMessage = 'Your search has expired';
  }
  if (code === _API_ERROR_CODES["default"].TF3006) {
    errorMessage = 'Invalid Insurance';
  }
  if (code === _API_ERROR_CODES["default"].TF3005) {
    errorMessage = 'Invalid Addon';
  }
  if (code === _API_ERROR_CODES["default"].CM1005) {
    errorMessage = 'Malformed Request Body'; // hardcoded for now
  }
  if (code === _API_ERROR_CODES["default"].CM1000) {
    errorMessage = 'Something went wrong. Please try again'; // hardcoded for now
  }
  if (code === _API_ERROR_CODES["default"].CM1002) {
    errorMessage = t('error_code_400_invalid_otp');
  }
  if (code === _API_ERROR_CODES["default"].CM1003) {
    errorMessage = t('Incorrect_password');
  }
  if (code === _API_ERROR_CODES["default"].CM1008) {
    errorMessage = 'You are not authorized'; // hardcoded for now by Vikas
  }
  if (code === _CUSTOM_ERROR_CODES["default"].PR404) {
    errorMessage = 'Could not load prices. Pls try later'; // hardcoded for now
  }
  if (code === _CUSTOM_ERROR_CODES["default"].CY404) {
    errorMessage = t('City_not_found');
  }
  if (code === _CUSTOM_ERROR_CODES["default"].GR404) {
    errorMessage = 'Could not load vehicles. Pls try later'; // hardcoded for now
  }
  if (code === _CUSTOM_ERROR_CODES["default"].CN404 || code === _CUSTOM_ERROR_CODES["default"].BR404) {
    errorMessage = t('nothing_found');
  }
  if (code === _CUSTOM_ERROR_CODES["default"].BL404) {
    errorMessage = 'No bookings available';
  }
  // CT3***
  if (code === _API_ERROR_CODES["default"].CT3000) {
    errorMessage = t('error_code_404_otp_not_found');
  }
  if (code === _API_ERROR_CODES["default"].CT3001) {
    errorMessage = t('error_code_400_email_exists');
  }
  if (code === _API_ERROR_CODES["default"].CT3002) {
    errorMessage = t('error_code_400_invalid_request_id');
  }
  if (code === _API_ERROR_CODES["default"].CT3003) {
    errorMessage = t('error_code_400_invalid_otp');
  }
  if (code === _API_ERROR_CODES["default"].CT3004) {
    errorMessage = t('error_code_400_otp_expired');
  }
  if (code === _API_ERROR_CODES["default"].CT3005) {
    errorMessage = t('incorrect_login_details');
  }
  if (code === _API_ERROR_CODES["default"].CT3012) {
    errorMessage = t('error_code_400_otp_already_sent');
  }
  if (code === _API_ERROR_CODES["default"].CT3035) {
    errorMessage = t('error_code_429_too_many_attempts');
  }
  if (code === _API_ERROR_CODES["default"].TF3009) {
    errorMessage = 'Invalid Booking Duration';
  }
  if (code === _API_ERROR_CODES["default"].BK3012) {
    errorMessage = 'Invalid or Expired Quote Id'; // better message
  }
  // when you are using the same quote Id for another booking
  if (code === _API_ERROR_CODES["default"].BK3019) {
    errorMessage = 'Booking already exists'; // previously - Driver already registered
  }
  // you are creating another booking with different quoteId
  // but their duration clashes with  the previous active booking
  if (code === _API_ERROR_CODES["default"].BK3003) {
    errorMessage = 'Booking Overlapping';
  }
  if (code === _API_ERROR_CODES["default"].BK3000) {
    errorMessage = 'Booking not found'; // better message
  }
  // this error happens when you try to make payment
  // before calling driver register in booking flow
  // first a driver has to be created against the quote id
  if (code === _API_ERROR_CODES["default"].BK3007) {
    errorMessage = 'Driver not found';
  }
  if (code === _API_ERROR_CODES["default"].PY3007) {
    errorMessage = 'Invalid or Used Token'; // old/wrong token passed from checkout frames call to /payment api
  }
  if (code === _API_ERROR_CODES["default"].CP3008) {
    errorMessage = 'Reservation already exist'; // pay by card again for an used quoteId
  }
  // error happens during payment status check
  // when wrong paymentType is passed in req body
  // eg. passed checkout for a pay_at_branch
  if (code === _API_ERROR_CODES["default"].PY3003) {
    errorMessage = 'Payment Not Generated from Lumi!';
  }
  // error came while fetching quote details
  if (code === _API_ERROR_CODES["default"].TF3013) {
    errorMessage = 'Invalid or Expired Quote Id';
  }
  // driver already exist on car pro
  if (code === _API_ERROR_CODES["default"].CP3024) {
    errorMessage = 'Driver already exist”';
  }
  if (code === _API_ERROR_CODES["default"].PY3001) {
    errorMessage = 'Payment not found';
  }
  if (code === _API_ERROR_CODES["default"].BK3015) {
    errorMessage = 'Payment status not found';
  }
  if (code === _API_ERROR_CODES["default"].BK3018) {
    errorMessage = 'Customer exists for driver details';
  }
  // when recaptcha verification fails.
  if (code === _API_ERROR_CODES["default"].CM1009) {
    errorMessage = 'Unexpected Guest';
  }
  if (code === _API_ERROR_CODES["default"].CP3033) {
    errorMessage = 'Email Already Exist';
  }
  if (code === _API_ERROR_CODES["default"].CP3006) {
    errorMessage = 'Invalid promo code';
  }
  if (code === _API_ERROR_CODES["default"].BK5000) {
    errorMessage = {
      title: t('BK5000_title'),
      desc: t('BK5000_subtitle')
    };
  }
  if (code === _API_ERROR_CODES["default"].BK5001) {
    errorMessage = {
      title: t('BK5001_title'),
      desc: t('BK5001_subtitle')
    };
  }
  if (code === _API_ERROR_CODES["default"].BK5002) {
    errorMessage = {
      title: t('BK5002_title'),
      desc: t('BK5002_subtitle')
    };
  }
  if (code === _API_ERROR_CODES["default"].BK5003) {
    errorMessage = {
      title: t('BK5003_title'),
      desc: t('BK5003_subtitle')
    };
  }
  if (code === _API_ERROR_CODES["default"].BK5004) {
    errorMessage = {
      title: t('BK5004_title'),
      desc: t('BK5004_subtitle')
    };
  }
  if (code === _API_ERROR_CODES["default"].BK5005) {
    errorMessage = {
      title: t('BK5005_title'),
      desc: t('BK5005_subtitle')
    };
  }
  if (code === _API_ERROR_CODES["default"].BK5006) {
    errorMessage = {
      title: t('BK5006_title'),
      desc: t('BK5006_subtitle')
    };
  }
  if (code === _API_ERROR_CODES["default"].TF3071) {
    errorMessage = t('input_error_message_can_not_recognize_email');
  }
  return {
    errorMessage: errorMessage,
    code: code
  };
}
var _default = exports["default"] = useAPIError;